import { BoxStyled, ImageIconStyled, ImgStyled } from './MethodsImageField.styled';

type MethodsImageFieldProps = {
  imgSrc?: string | null;
};

export const MethodsImageField: React.FC<MethodsImageFieldProps> = ({ imgSrc }) =>
  imgSrc ? (
    <ImgStyled alt={imgSrc} src={imgSrc} />
  ) : (
    <BoxStyled>
      <ImageIconStyled color="disabled" />
    </BoxStyled>
  );
